import {
  Avatar,
  Box,
  Checkbox,
  Chip,
  colors,
  Fab,
  Grid,
  IconButton,
  Paper,
  Tab,
  TableRow,
  tabsClasses,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeIcon from "@mui/icons-material/Mode";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  create_organisation_paymentRequest,
  get_all_followups,
  get_company_member_list,
  get_company_members_summary,
  getAvailableAccess,
  getDocuments,
  getMembersSummary,
  update_company_member,
  update_followup,
} from "../Redux/Actions/action";
import { showLoader } from "../Redux/Slices/loaderSlice";
import StatusBox from "../Components/Documents/StatusBox";
import CommonSearchField from "../Components/Common/CommonSearchField";
import CommonTable from "../Components/Common/CommonTable";
import StyledTableCell from "../Components/Common/styledTableCell";
import ErrorHandler, {
  capitalizeFirstLetterOfWords,
  checkAccess,
  CommonChip,
  CommonChipFollowUpStatus,
  getValuebyId,
  PaymentShowBox,
} from "../Utils/handler";
import CustomPagination from "../Components/Common/CommonPagination";
import { BucketURL } from "../ApiSetup/Api";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { TabContext, TabList } from "@mui/lab";
import DataNotFound from "../Components/Common/DataNotFound";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import dayjs from "dayjs";
import CustomDialog from "../Components/Common/CustomDialog";
import ButtonContained from "../Components/Common/ButtonContained";
import CommonDropDown from "../Components/Common/CommonDropDown";
import { followUpStatusNotInterSted } from "../Utils/enum";
import TextLabel from "../Components/Common/CommonTextLabel";
import CommonTextField from "../Components/Common/CommonTextField";
import { useSelector } from "react-redux";
import ExcelJS from "exceljs";
import * as FileSaver from "file-saver";
import SimCardDownloadOutlinedIcon from "@mui/icons-material/SimCardDownloadOutlined";
import sessionStoreUtil from "../ApiSetup/Localstorage";
import SearchIcon from '@mui/icons-material/Search';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

const useStyles = makeStyles()((theme) => ({
  TabList: {
    "& .Mui-selected": {
      fontWeight: "bold",
    },
  },
  TabDesign: {
    backgroundColor: "transparent",
    borderRadius: "6px",
    color: "#3E4094",
    minHeight: "40px",
    maxHeight: "50px",
    minWidth: "auto",
    "&.Mui-selected": {
      backgroundColor: theme?.palette?.bgLightWeight?.main,
    },
  },
}));

function ViewMember() {
  // ---------- Hook -----------
  const { classes } = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const sm = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dataAccess = useSelector(
    (value) => value?.allAvailableAccess?.AllAvailableAccessList
  );
  const availableAccess = dataAccess?.filter((e) => e.path === pathname)?.[0]
    ?.actionsType;
  const user = sessionStoreUtil.getLSItem("userData")
    ? JSON.parse(sessionStoreUtil.getLSItem("userData"))
    : {};

  const [searchParams, setSearchParams] = useSearchParams();

  // --------------- State -------------
  const [tableData, setTableData] = useState({});
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [searchText, setSearchText] = useState("");
  const [candidate, setCandidate] = useState({});
  const [membersSummary, setMembersSummary] = useState();
  const [open, setOpen] = useState(false);
  const [memberId, setMemberId] = useState({});
  const [allFollowups, setAllFollowups] = useState();
  const [followUpStatus, setFollowUpStatus] = useState({
    followUpStatus: "",
    remark: "",
  });
  const [error, setError] = useState("");
  const [data, setData] = useState({});
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [isAssignedModal, setIsAssignedModal] = useState(false);
  const [sorting, setSorting] = useState({
    isPpskId: "",
    isSubmittedDate: "",
    isUpdatedDate: "",
    isRenewDays: "",
    isVerifyBy: "",
    isPaymentDate: ""
  });
  const [isSearch, setIsSearch] = useState(false);

  const isSelected = (id) => selectedMembers?.indexOf(id) !== -1;

  const tabData = [
    {
      label: "Pending",
      value: "0",
      tabLabel: "Pending Tab",
      isView: availableAccess?.some((e) => e === "Pending Tab"),
      color: theme.palette.primary.main
    },
    {
      label: "Completed",
      value: "1",
      tabLabel: "Completed Tab",
      isView: availableAccess?.some((e) => e === "Completed Tab"),
      color: theme.palette.warning.main
    },
    {
      label: "Approved",
      value: "2",
      tabLabel: "Approved Tab",
      isView: availableAccess?.some((e) => e === "Approved Tab"),
      color: "rgba(11, 176, 108, 1)"
    },
    {
      label: "Rejected",
      value: "3",
      tabLabel: "Rejected Tab",
      isView: availableAccess?.some((e) => e === "Rejected Tab"),
      color: "rgba(227, 54, 41, 1)"
    },
    {
      label: "Partial-Rejected",
      value: "4",
      tabLabel: "Partial-Rejected Tab",
      isView: availableAccess?.some((e) => e === "Partial-Rejected Tab"),
      color: "rgba(252, 171, 17, 1)"
    },
    {
      label: "Re-Upload",
      value: "5",
      tabLabel: "Re-Upload Tab",
      isView: availableAccess?.some((e) => e === "Re-Upload Tab"),
      color: "rgba(245, 134, 52, 1)"
    },
    {
      label: "Submit-To-Office",
      value: "6",
      tabLabel: "Submit-To-Office Tab",
      isView: availableAccess?.some((e) => e === "Submit-To-Office Tab"),
      color: "rgba(2, 88, 100, 1)"
    },
    {
      label: "Payment Request",
      value: "7",
      tabLabel: "Payment Request Tab",
      isView: availableAccess?.some((e) => e === "Payment Request Tab"),
      color: theme.palette.panddingPaymant.main
    },
    {
      label: "Verified Payers",
      value: "8",
      tabLabel: "Verified Payers Tab",
      isView: availableAccess?.some((e) => e === "Verified Payers Tab"),
      color: theme.palette.info.main
    },
  ];

  const tabDataAdmin = [
    {
      label: "Submit-To-Office",
      value: "6",
      tabLabel: "Submit-To-Office Tab",
      isView: availableAccess?.some((e) => e === "Submit-To-Office Tab"),
      color: "rgba(2, 88, 100, 1)"
    },
    {
      label: "Partial-Rejected",
      value: "4",
      tabLabel: "Partial-Rejected Tab",
      isView: availableAccess?.some((e) => e === "Partial-Rejected Tab"),
      color: "rgba(252, 171, 17, 1)"
    },
    {
      label: "Rejected",
      value: "3",
      tabLabel: "Rejected Tab",
      isView: availableAccess?.some((e) => e === "Rejected Tab"),
      color: "rgba(227, 54, 41, 1)"
    },
    {
      label: "Approved",
      value: "2",
      tabLabel: "Approved Tab",
      isView: availableAccess?.some((e) => e === "Approved Tab"),
      color: "rgba(11, 176, 108, 1)"
    },
    {
      label: "Re-Upload",
      value: "5",
      tabLabel: "Re-Upload Tab",
      isView: availableAccess?.some((e) => e === "Re-Upload Tab"),
      color: "rgba(245, 134, 52, 1)"
    },
    {
      label: "Payment Request",
      value: "7",
      tabLabel: "Payment Request Tab",
      isView: availableAccess?.some((e) => e === "Payment Request Tab"),
      color: theme.palette.panddingPaymant.main
    },
    {
      label: "Verified Payers",
      value: "8",
      tabLabel: "Verified Payers Tab",
      isView: availableAccess?.some((e) => e === "Verified Payers Tab"),
      color: theme.palette.info.main
    },
  ];

  const urlTab = searchParams.get("tab");
  
  // Get the first available tab value as fallback
  const getDefaultTab = () => {
    if (user?.organisationName === "PPSK") {
      const viewableTab = tabDataAdmin.find((tab) => tab.isView);
      return viewableTab?.value || tabDataAdmin[0]?.value || "6";
    } else {
      const viewableTab = tabData.find((tab) => tab.isView);
      return viewableTab?.value || tabData[0]?.value || "0";
    }
  };
  
  const defaultTab = getDefaultTab();

  const initialTab =
    user?.organisationName === "PPSK"
      ? tabDataAdmin?.some((tab) => tab.value === urlTab)
        ? urlTab
        : defaultTab
      : tabData?.some((tab) => tab.value === urlTab)
        ? urlTab
        : defaultTab;

  const [tabValue, setTabValue] = useState(initialTab);
  const [value, setValue] = useState(initialTab);

  // --------------- handleChange ---------------
  const handelChangeFlolowUp = (e) => {
    const { name, value } = e.target;

    setFollowUpStatus({
      ...followUpStatus,
      [name]: value,
    });
  };

  const handleClear = () => {
    setOpen(false);
    setFollowUpStatus({
      followUpStatus: "",
      remark: "",
    });
    setError("");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const viewHandler = (item) => {
    navigate(`/admin/documents-view?id=${item._id}`);
    setCandidate(item);
  };

  const _generateExcel = (data) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet 1");

    const headerRowValues = [
      "No",
      "PPSK Id",
      "Name",
      "Contact No.",
      "Reference Contact No.",
      "Gender",
      "Submitted Date",
      "Updated Date",
      "Status",
      "Payment Status",
      "Followup Status",
      "Assigned To",
    ];
    const headerRow = worksheet.addRow(headerRowValues);

    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "3e4094" }, // Background color
      };
      cell.font = { bold: true, color: { argb: "FFFFFF" } }; // White text, bold font
    });
    // Add data rows
    data?.forEach((document, index) => {
      worksheet.addRow([
        index + 1,
        document?.ppskId || "-",
        document?.fullName || "-",
        document?.phoneNumber || "-",
        document?.otherDetails?.referencePersonContactNumber || "-",
        document?.personalDetails?.gender || "-",
        dayjs(document?.createdAt).format("ll") || "-",
        dayjs(document?.updatedAt).format("ll") || "-",
        document?.verificationStatus || "-",
        document?.policyStatus?.transaction?.status || "-",
        document?.followUpStatus || "-",
        document?.assigneeName || "-",
      ]);
    });

    worksheet.columns = [
      { width: 10 },
      { width: 20 },
      { width: 40 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 40 },
    ];
    // Save workbook to file
    workbook.xlsx
      .writeBuffer()
      .then((buffer) => {
        const data = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(
          data,
          `${`${value === "0"
            ? "Pending"
            : value === "1"
              ? "Completed"
              : value === "2"
                ? "Approved"
                : value === "3"
                  ? "Rejected"
                  : value === "4"
                    ? "Partial-Rejected"
                    : value === "5"
                      ? "Re-Upload"
                      : value === "6"
                        ? "Submit-To-Office"
                        : value === "7"
                          ? "Payment Request"
                          : value === "8"
                            ? "Verified Payers"
                            : ""
          } Members ${dayjs(new Date()).format("DD/MM/YYYY")}`}`
        );
      })
      .catch((err) => {
        console.error("Error generating Excel:", err);
      });
  };

  // --------------- Api  ---------------
  const getAllFollowups = async (id) => {
    dispatch(showLoader(true));
    let body = { id: id };
    try {
      const result = await dispatch(get_all_followups(body));
      const error = ErrorHandler(result);
      if (error) {
        setAllFollowups(result?.payload?.data?.followUps);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _addFollowups = async () => {
    if (!followUpStatus?.followUpStatus) {
      setError({ followUpStatus: "* Please select any status!" });
      return;
    }
    dispatch(showLoader(true));
    try {
      let body = {
        id: memberId,
        currentStatus: getValuebyId(
          followUpStatus?.followUpStatus,
          followUpStatusNotInterSted
        ),
        remark: followUpStatus?.remark || "",
      };
      const result = await dispatch(update_followup(body));
      const error = ErrorHandler(result);
      if (error) {
        toast.success(result?.payload?.message);
        _getSummaryDetails();
        setFollowUpStatus({ followUpStatus: "", remark: "" });
        setOpen(false);
        setError({});
        _getDocumetsData();
      }
    } catch (error) {
      toast.error(error?.message || "An unknown error occurred");
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _update_company_member = async () => {
    dispatch(showLoader(true));
    try {
      let body = {
        verificationStatus:
          value == "0"
            ? "Completed"
            : value == "1"
              ? "Submit-To-Office"
              : "Payment Request",
        memberIds: selectedMembers,
      };
      const result = await dispatch(update_company_member(body));
      const error = ErrorHandler(result);
      if (error) {
        toast.success(result?.payload?.message);
        setSelectedMembers([]);
        setIsAssignedModal(false);
        _getDocumetsData();
        _getSummaryDetails();
        if (value == "2" || value == "8") {
          dispatch(showLoader(true));
          try {
            let body = {
              userIds: selectedMembers,
            };
            const result = await dispatch(
              create_organisation_paymentRequest(body)
            );
            const error = ErrorHandler(result);
            if (error) {
            }
          } catch (error) {
            toast.error(error?.message || "An unknown error occurred");
          } finally {
            dispatch(showLoader(false));
          }
        }
      }
    } catch (error) {
      toast.error(error?.message || "An unknown error occurred");
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _getDocumetsData = async () => {
    dispatch(showLoader(true));
    const verificationStatus =
      value === "0"
        ? "Pending"
        : value === "1"
          ? "Completed"
          : value === "2"
            ? "Approved"
            : value === "3"
              ? "Rejected"
              : value === "4"
                ? "Partial-Rejected"
                : value === "5"
                  ? "Re-Upload"
                  : value === "6"
                    ? "Submit-To-Office"
                    : value === "7"
                      ? "Payment Request"
                      : value === "8"
                        ? "Verified Payers"
                        : "";
    let body = {
      search: searchText || "",
      page: page,
      limit: rowsPerPage,
      verificationStatus: verificationStatus,
      isPpskId: sorting?.isPpskId ? +sorting?.isPpskId : "",
      isSubmittedDate: sorting?.isSubmittedDate ? +sorting?.isSubmittedDate : "",
      isUpdatedDate: sorting?.isUpdatedDate ? +sorting?.isUpdatedDate : "",
      isRenewDays: sorting?.isRenewDays ? +sorting?.isRenewDays : "",
      isVerifyBy: sorting?.isVerifyBy ? +sorting?.isVerifyBy : "",
      isPaymentDate: sorting?.isPaymentDate ? +sorting?.isPaymentDate : "",
    };

    try {
      const result = await dispatch(get_company_member_list(body));
      const error = ErrorHandler(result);
      if (error) {
        // toast.success(result?.payload?.message);
        setTableData(result?.payload?.data);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _getSummaryDetails = async () => {
    dispatch(showLoader(true));
    let body = {};
    try {
      const result = await dispatch(get_company_members_summary(body));
      const error = ErrorHandler(result);
      if (error) {
        setMembersSummary(result?.payload?.data?.counts);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _downloadMembers = async () => {
    dispatch(showLoader(true));
    const verificationStatus =
      value === "0"
        ? "Pending"
        : value === "1"
          ? "Completed"
          : value === "2"
            ? "Approved"
            : value === "3"
              ? "Rejected"
              : value === "4"
                ? "Partial-Rejected"
                : value === "5"
                  ? "Re-Upload"
                  : value === "6"
                    ? "Submit-To-Office"
                    : value === "7"
                      ? "Payment Request"
                      : value === "8"
                        ? "Verified Payers"
                        : "";
    let body = {
      search: searchText || "",
      verificationStatus: verificationStatus,
      isPpskId: sorting?.isPpskId ? +sorting?.isPpskId : "",
      isSubmittedDate: sorting?.isSubmittedDate ? +sorting?.isSubmittedDate : "",
      isUpdatedDate: sorting?.isUpdatedDate ? +sorting?.isUpdatedDate : "",
      isRenewDays: sorting?.isRenewDays ? +sorting?.isRenewDays : "",
      isVerifyBy: sorting?.isVerifyBy ? +sorting?.isVerifyBy : "",
      isPaymentDate: sorting?.isPaymentDate ? +sorting?.isPaymentDate : "",
    };
    try {
      const result = await dispatch(get_company_member_list(body));
      const error = ErrorHandler(result);
      if (error) {
        _generateExcel(result?.payload?.data?.members);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const handleClick = (event, id, status) => {
    // Prevent row click event from selecting the checkbox
    event.stopPropagation();
    if (status === 3 && status === 4) return;

    const selectedIndex = selectedMembers?.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedMembers, id);
    } else {
      newSelected = selectedMembers?.filter((item) => item !== id);
    }
    setSelectedMembers(newSelected);
  };

  const handleCheckboxClick = (event, id) => {
    event.stopPropagation();
    handleClick(event, id);
  };

  // --------- useEffect ----------
  useEffect(() => {
    _getSummaryDetails();
  }, [value]);

  useEffect(() => {
    _getDocumetsData();
  }, [page, rowsPerPage, value, searchText, sorting]);

  useEffect(() => {
    setSearchParams({ tab: tabValue }); // Store tab number in URL
  }, [tabValue, setSearchParams]);

  const tableHeaders = [
    user?.organisationName !== "PPSK" &&
      (value == "0" || value == "1" || value == "2") ? (
      <Checkbox
        key="select-all-checkbox"
        color="success"
        indeterminate={
          selectedMembers.length > 0 &&
          selectedMembers.length < tableData?.members?.length
        }
        checked={
          tableData?.members?.length > 0 &&
          selectedMembers?.length === tableData?.members?.length
        }
        onChange={(event) => {
          const newSelected = event.target.checked
            ? tableData?.members?.map((item) => item._id)
            : [];
          setSelectedMembers(newSelected);
        }}
        sx={{ "& .MuiSvgIcon-root": { color: "#ffffff" } }}
      />
    ) : value == "8" && user?.organisationName !== "PPSK" ? (
      " "
    ) : (
      ""
    ),
    "No",
    "Photo",
    "PPSK ID",
    "Name",
    "Mobile No",
    "Gender",
    "Added By",
    "Family Members",
    "Submitted Date",
    value === "8" && "Expired At",
    "Updated Date",
    value === "0" && "Followup Status",
    value === "2" && "Payment",
    value === "2" && "Payment Date",
    value === "2" && "Start Date",
    value === "2" && "End Date",
    value === "2" && "Remaining Renew Days",
    value === "2" && "Verified By",
    user?.organisationName == "PPSK"
      ? value !== "0" &&
      value !== "1" &&
      (checkAccess(pathname, dataAccess, "Action View") ||
        checkAccess(pathname, dataAccess, "Action Edit")) &&
      "Action"
      : (checkAccess(pathname, dataAccess, "Action View") ||
        checkAccess(pathname, dataAccess, "Action Edit")) &&
      "Action",
  ]?.filter(Boolean);

  return (
    <Grid container spacing={2} xs={12} sm={12} md={12} lg={12}>
      <Grid item xs={12}>
        <Paper
          elevation={0}
          sx={{ padding: 2, background: { md: "#fff", xs: "none" }, borderRadius: '20px', border: `1px solid lightgrey` }}
        >
          <Box
            display={"flex"}
            justifyContent={"end"}
            alignItems={{ sm: "center", xs: "start" }}
            mb={1}
            gap={1}
            flexDirection={{ sm: "row", xs: "column" }}
          >
            <Tooltip title={`Search`}>
              {!isSearch &&
                <Fab sx={{
                  width: '46px', height: '42px', boxShadow: 'none', minHeight: "30px", padding: 0, border: '1px solid rgba(34, 34, 34, 0.3)', borderRadius: '10px', backgroundColor: "transparent", color: "rgba(34, 34, 34, 0.3)",
                }} onClick={() => setIsSearch(true)}>
                  <SearchIcon sx={{ fontSize: '24px' }} />
                </Fab>
              }
              {isSearch &&
                <CommonSearchField placeholder={"Search.."} tooltipList={['Name', "AadharCard Number", "Mobile Number"]} handleSearch={(e) => { setPage(1); setSearchText(e); }} />
              }
            </Tooltip>
            <Tooltip
              title={`Download ${value === "0"
                ? "Pending"
                : value === "1"
                  ? "Completed"
                  : value === "2"
                    ? "Approved"
                    : value === "3"
                      ? "Rejected"
                      : value === "4"
                        ? "Partial-Rejected"
                        : value === "5"
                          ? "Re-Upload"
                          : value === "6"
                            ? "Submit-To-Office"
                            : value === "7"
                              ? "Payment Request"
                              : value === "8"
                                ? "Verified Payers"
                                : ""
                } Member`}
            >
              <Fab disabled={tableData?.members?.length === 0} color='primary' sx={{
                width: '56px', height: '42px', boxShadow: 'none', minHeight: "30px", padding: 0, borderRadius: '10px', backgroundColor: user?.organisationName === "PPSK" ? tabDataAdmin?.filter((e) => e?.value == tabValue)?.[0]?.color : tabData?.filter((e) => e?.value == tabValue)?.[0]?.color, color: theme.palette.common.white, "&:hover": {
                  background: user?.organisationName === "PPSK" ? tabDataAdmin?.filter((e) => e?.value == tabValue)?.[0]?.color : tabData?.filter((e) => e?.value == tabValue)?.[0]?.color, color: theme.palette.common.white
                }
              }} onClick={() => _downloadMembers()}>
                <FileDownloadOutlinedIcon sx={{ fontSize: '24px' }} />
              </Fab>
            </Tooltip>
          </Box>
          {user?.organisationName !== "PPSK" &&
            (value == "0" || value == "1" || value == "2" || value == "8") && (
              <Grid
                item
                xs={12}
                display={"flex"}
                gap={"10px"}
                justifyContent={"flex-end"}
                alignItems={"center"}
                mb={2}
              >
                <ButtonContained
                  text={
                    value === "0"
                      ? "Move to Completed"
                      : value === "1"
                        ? "Move to PPSK Office"
                        : "Move to Payment Request"
                  }
                  fontSize={{ xs: "13px", md: "14px" }}
                  height={"35px"}
                  onClick={() => setIsAssignedModal(true)}
                  disabled={selectedMembers.length > 0 ? false : true}
                />
              </Grid>
            )}

          <TabContext value={value}>
            <Box mb={1}>
              <TabList
                onChange={(e, newValue) => {
                  setValue(newValue);
                  setPage(1);
                  setTabValue(newValue);
                  setSorting({
                    isPpskId: "",
                    isSubmittedDate: "",
                    isUpdatedDate: "",
                    isRenewDays: "",
                    isVerifyBy: "",
                    isPaymentDate: ""
                  })
                }}
                aria-label="tabs with icons"
                sx={{
                  "& .MuiTabs-indicator": {
                    display: "none",
                  },
                  "& .Mui-selected": {
                    background: user?.organisationName === "PPSK" ? tabDataAdmin?.filter((e) => e?.value == tabValue)?.[0]?.color : tabData?.filter((e) => e?.value == tabValue)?.[0]?.color,
                    color: `${theme.palette.common.white} !important`
                  },
                  [`& .${tabsClasses.scrollButtons}`]: {
                    '&.Mui-disabled': { opacity: 0.3 },
                  }
                }}
                variant="scrollable"
                scrollButtons="auto"

              >
                {user?.organisationName === "PPSK"
                  ? tabDataAdmin?.map((tab, index) => {
                    return (
                      checkAccess(pathname, dataAccess, tab?.tabLabel) && (
                        <Tab
                          key={tab?.value || index}
                          label={`${tab?.label} (${membersSummary?.find(
                            (e) => e?.status == tab?.label
                          )?.statusCount || 0
                            })`}
                          value={tab?.value}
                          sx={{ marginRight: '10px', border: `2px solid ${tab.color}`, borderRadius: '10px', color: tab.color, height: '40px', minHeight: '0px' }}
                        />
                      )
                    );
                  })
                  : tabData?.map((tab, index) => {
                    return (
                      checkAccess(pathname, dataAccess, tab?.tabLabel) && (
                        <Tab
                          key={tab?.value || index}
                          label={`${tab?.label} (${membersSummary?.find(
                            (e) => e?.status == tab?.label
                          )?.statusCount || 0
                            })`}
                          value={tab?.value}
                          sx={{ marginRight: '10px', border: `2px solid ${tab.color}`, borderRadius: '10px', color: tab.color, }}
                        />
                      )
                    );
                  })}
              </TabList>
            </Box>
          </TabContext>

          <CommonTable
            headerList={tableHeaders}
            align={"center"}
            minWidth={600}
            setSorting={setSorting} sorting={sorting}
            backgroundColor={user?.organisationName === "PPSK" ? tabDataAdmin?.filter((e) => e?.value == tabValue)?.[0]?.color : tabData?.filter((e) => e?.value == tabValue)?.[0]?.color}
          >
            {tableData?.members?.length > 0 ? (
              tableData?.members?.map((document, index) => {
                let image = document?.personalDetails?.image
                  ? BucketURL + document?.personalDetails?.image
                  : "No";
                const isItemSelected = isSelected(document?._id);
                return (
                  <TableRow key={index}>
                    {user?.organisationName !== "PPSK" &&
                      (value == "0" ||
                        value == "1" ||
                        value == "2" ||
                        value == "8") && (
                        <StyledTableCell align="center">
                          <Checkbox
                            color="primary"
                            checked={isItemSelected}
                            onChange={(event) =>
                              handleCheckboxClick(event, document?._id)
                            }
                            sx={{
                              "& .MuiSvgIcon-root": { color: "#666666" },
                              opacity:
                                value == "8" && !document?.isShowExpireAt
                                  ? 0.5
                                  : 1,
                            }}
                            disabled={value == "8" && !document?.isShowExpireAt}
                          />
                        </StyledTableCell>
                      )}
                    <StyledTableCell
                      sx={{
                        position: "relative",
                        padding: "0px",
                        width: "75px",
                      }}
                      align="center"
                    >
                      {/* <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          margin: "-5px 0px 0px -2px",
                        }}
                      >
                        <CommonChip
                          label={document?.verificationStatus}
                          status={document?.verificationStatus}
                          height={"20px"}
                          width={"auto"}
                          margin={"18px 0px 0px 2px"}
                          padding={"2px 8px"}
                        />
                      </Box> */}
                      <Box>
                        {(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}
                      </Box>
                    </StyledTableCell>

                    <StyledTableCell align="center" >
                      <Box display={'flex'} justifyContent={'center'}>
                        <Avatar src={image} slotProps={{ img: { loading: 'lazy', } }} sx={{ borderRadius: '6px' }} />
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {document?.ppskId}
                    </StyledTableCell>
                    <StyledTableCell align="center">{capitalizeFirstLetterOfWords(document?.fullName || "-")}</StyledTableCell>
                    <StyledTableCell align="center">{document?.phoneNumber ? document?.phoneNumber : document?.personalDetails?.phoneNumber ? document?.personalDetails?.phoneNumber : "-"}</StyledTableCell>
                    <StyledTableCell align="center" sx={{ textTransform: 'capitalize' }}>
                      {capitalizeFirstLetterOfWords(document?.personalDetails?.gender || "-")}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {document?.addedByUser ? (
                        <Tooltip title={`Created by: ${document?.addedByUser?.phoneNumber || ''}`}>
                          <span style={{ cursor: 'pointer' }}>
                            {capitalizeFirstLetterOfWords(document?.addedByUser?.fullName || "-")}
                          </span>
                        </Tooltip>
                      ) : document?.linkedByUsers?.length > 0 ? (
                        <Tooltip 
                          title={
                            <Box>
                              <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Linked by:
                              </Typography>
                              {document?.linkedByUsers?.map((user, idx) => (
                                <Box key={idx} sx={{ mb: 0.5 }}>
                                  • {user?.fullName || 'N/A'} ({user?.phoneNumber || 'N/A'})
                                </Box>
                              ))}
                            </Box>
                          }
                        >
                          <Chip 
                            label={`Linked by ${document?.linkedByUsers?.length}`}
                            size="small"
                            color="secondary"
                            variant="outlined"
                            sx={{ cursor: 'pointer' }}
                          />
                        </Tooltip>
                      ) : (
                        <span style={{ color: '#888' }}>Self</span>
                      )}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {document?.familyMemberCount > 0 ? (
                        <Tooltip 
                          title={
                            <Box>
                              <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Linked Family Members:
                              </Typography>
                              {document?.linkedFamilyMembers?.map((member, idx) => (
                                <Box key={idx} sx={{ mb: 0.5 }}>
                                  • {member?.fullName || 'N/A'} ({member?.phoneNumber || 'N/A'})
                                  <Chip 
                                    label={member?.verificationStatus || 'N/A'} 
                                    size="small" 
                                    sx={{ ml: 1, height: '18px', fontSize: '10px' }}
                                  />
                                </Box>
                              ))}
                            </Box>
                          }
                        >
                          <Chip 
                            label={`${document?.familyMemberCount} member${document?.familyMemberCount > 1 ? 's' : ''}`}
                            size="small"
                            color="primary"
                            variant="outlined"
                            sx={{ cursor: 'pointer' }}
                          />
                        </Tooltip>
                      ) : (
                        <span style={{ color: '#888' }}>-</span>
                      )}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {dayjs(document?.createdAt).format("ll") || "-"}
                    </StyledTableCell>
                    {value === "8" && (
                      <StyledTableCell
                        align="center"
                        style={{
                          color: document?.isShowExpireAt
                            ? theme.palette.error.main
                            : theme.palette.success.main,
                        }}
                      >
                        {dayjs(document?.policyStatus?.expireAt).diff(
                          dayjs(),
                          "day"
                        ) + " days left"}
                      </StyledTableCell>
                    )}
                    <StyledTableCell align="center">
                      {dayjs(document?.updatedAt).format("ll") || ""}
                    </StyledTableCell>
                    {value === "2" && (
                      <StyledTableCell align="center">
                        <PaymentShowBox
                          value={
                            document?.policyStatus?.transaction?.status ||
                            "PENDING"
                          }
                        />
                      </StyledTableCell>
                    )}
                    {
                      value === '2' &&
                      <StyledTableCell align="center">{document?.policyStatus?.transactionDate ? dayjs(document?.policyStatus?.transactionDate).format("ll") : "-"}</StyledTableCell>
                    }
                    {
                      value === '2' &&
                      <StyledTableCell align="center">{document?.policyStatus?.activeAt ? dayjs(document?.policyStatus?.activeAt).format("ll") : "-"}</StyledTableCell>
                    }
                    {
                      value === '2' &&
                      <StyledTableCell align="center">{document?.policyStatus?.expireAt ? dayjs(document?.policyStatus?.expireAt).format("ll") : "-"}</StyledTableCell>
                    }
                    {
                      value === '2' && <StyledTableCell align="center">
                        {document?.policyStatus?.remainingRenewDays ? document?.policyStatus?.remainingRenewDays + " days left" : "-"}
                      </StyledTableCell>
                    }
                    {value === "0" && (
                      <StyledTableCell
                        align="center"
                        onClick={() => {
                          setOpen(true);
                          setMemberId(document?._id);
                          getAllFollowups(document?._id);
                        }}
                      >
                        <Box
                          sx={{
                            cursor: "pointer",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Tooltip title={document?.followUpStatus}>
                            <Box width={"100px"}>
                              <CommonChipFollowUpStatus
                                fontSize={"13px"}
                                height={"28px"}
                                label={document?.followUpStatus}
                              />
                            </Box>
                          </Tooltip>
                        </Box>
                      </StyledTableCell>
                    )}

                    {value === "2" && (
                      <StyledTableCell align="center">
                        {document?.documentVerificationStatus?.verifiedBy ||
                          "-"}
                      </StyledTableCell>
                    )}
                    {(user?.organisationName == "PPSK"
                      ? value !== "0" &&
                      value !== "1" &&
                      (checkAccess(pathname, dataAccess, "Action View") ||
                        checkAccess(pathname, dataAccess, "Action Edit"))
                      : checkAccess(pathname, dataAccess, "Action View") ||
                      checkAccess(pathname, dataAccess, "Action Edit")) && (
                        <StyledTableCell align="center">
                          {document?.verificationStatus === "Draft"
                            ? checkAccess(
                              pathname,
                              dataAccess,
                              "Action Edit"
                            ) && (
                              <IconButton
                                sx={{ padding: 1 }}
                                onClick={() =>
                                  navigate(
                                    `/admin/addMember?id=${document?._id}&tabValue=${value}&step=0&isEdit=${true}`
                                  )
                                }
                              >
                                <ModeIcon fontSize="medium" color="primary" />
                              </IconButton>
                            )
                            : checkAccess(
                              pathname,
                              dataAccess,
                              "Action View"
                            ) && (
                              <IconButton
                                sx={{ padding: 1 }}
                                onClick={() => viewHandler(document)}
                              >
                                <VisibilityIcon
                                  fontSize="medium"
                                  color="primary"
                                />
                              </IconButton>
                            )}
                        </StyledTableCell>
                      )}
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <StyledTableCell colSpan={12}>
                  <DataNotFound
                    title={"No Records Found"}
                    icon={
                      <ErrorOutlineIcon
                        color="primary"
                        style={{ fontSize: "2rem" }}
                      />
                    }
                    elevation={0}
                  />
                </StyledTableCell>
              </TableRow>
            )}
          </CommonTable>

          {tableData?.count > 0 && (
            <Grid item xs={12}>
              <CustomPagination
                rowsPerPageOptions={[5, 10, 25, 50, 75, 100]}
                count={Math.ceil(tableData?.count / rowsPerPage)}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>
          )}
        </Paper>
      </Grid>

      {
        isAssignedModal && (
          <CustomDialog
            isOpen={isAssignedModal}
            handleClose={() => {
              setIsAssignedModal(false);
            }}
            title={"Confirmation"}
            padding={"10px"}
            width={400}
            action={
              <>
                <ButtonContained
                  text={"No"}
                  onClick={() => setIsAssignedModal(false)}
                  minWidth={"48%"}
                  marginTop={"10px"}
                />
                <ButtonContained
                  text={"Yes"}
                  onClick={() => _update_company_member()}
                  minWidth={"50%"}
                  marginTop={"10px"}
                />
              </>
            }
          >
            <Typography textAlign={"center"}>
              {" "}
              Are you sure you want to proceed?
            </Typography>
          </CustomDialog>
        )
      }

      {
        open && (
          <CustomDialog
            isOpen={open}
            handleClose={handleClear}
            title={"Follow Up"}
            padding={"10px"}
            maxWidth={"sm"}
            action={
              <ButtonContained
                text={"Update"}
                onClick={() => _addFollowups()}
                minWidth={"auto"}
              />
            }
          >
            <Grid container xs={12} spacing={1}>
              <Grid item xs={12}>
                {allFollowups?.length > 0 &&
                  allFollowups?.map((data, i) => {
                    return (
                      <>
                        <Grid
                          container
                          key={data?._id}
                          alignItems="center"
                          my={1}
                        >
                          {/* Status Button */}
                          <Grid
                            item
                            xs={12}
                            textAlign={"center"}
                            sx={{
                              border: `1px dashed ${theme.palette.primary.main}`,
                              borderRadius: "5px",
                              padding: "5px",
                            }}
                          >
                            <Box
                              display={"flex"}
                              justifyContent={"space-between"}
                            >
                              <Box
                                display={"flex"}
                                flexDirection={"column"}
                                alignItems={"start"}
                                gap={"5px"}
                              >
                                <Box
                                  display={"flex"}
                                  alignItems={"center"}
                                  gap={0.5}
                                >
                                  <Typography
                                    color={theme.palette.primary.main}
                                    fontSize={"12px"}
                                  >
                                    Status :{" "}
                                  </Typography>
                                  <Typography variant="body1">
                                    <CommonChipFollowUpStatus
                                      label={data?.currentStatus}
                                    />
                                  </Typography>
                                </Box>

                                <Box
                                  display={"flex"}
                                  alignItems={"center"}
                                  gap={0.5}
                                >
                                  <Typography
                                    color={theme.palette.primary.main}
                                    fontSize={"12px"}
                                  >
                                    Date :
                                  </Typography>
                                  <Typography variant="body2">
                                    {" "}
                                    {data?.createdAt
                                      ? dayjs(data?.createdAt).format("LL")
                                      : "-"}{" "}
                                  </Typography>
                                </Box>
                              </Box>

                              <Box
                                display={"flex"}
                                flexDirection={"column"}
                                alignItems={"start"}
                                gap={"5px"}
                              >
                                <Box
                                  display={"flex"}
                                  alignItems={"center"}
                                  gap={0.5}
                                >
                                  <Typography
                                    color={theme.palette.primary.main}
                                    fontSize={"12px"}
                                  >
                                    Verify By :
                                  </Typography>
                                  <Typography variant="body2">
                                    {" "}
                                    {data?.changedBy}{" "}
                                  </Typography>
                                </Box>

                                <Box
                                  display={"flex"}
                                  alignItems={"center"}
                                  gap={0.5}
                                >
                                  <Typography
                                    color={theme.palette.primary.main}
                                    fontSize={"12px"}
                                  >
                                    Remark :
                                  </Typography>
                                  <Tooltip title={data?.remark}>
                                    <Box
                                      width={"120px"}
                                      textAlign={"start"}
                                      sx={{ cursor: "pointer" }}
                                    >
                                      <Typography variant="body2" noWrap>
                                        {data?.remark || "-"}
                                      </Typography>
                                    </Box>
                                  </Tooltip>
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                        </Grid>
                      </>
                    );
                  })}
              </Grid>

              <Grid item xs={12}>
                <CommonDropDown
                  type="text"
                  text={"Follow Up Status"}
                  name={"followUpStatus"}
                  value={followUpStatus?.followUpStatus}
                  values={followUpStatusNotInterSted?.map((e) => e?.label) || []}
                  labelColor={theme?.palette?.primary?.main}
                  placeholder={`Select Id Proof`}
                  width={"100%"}
                  valid
                  onChange={handelChangeFlolowUp}
                />
                <TextLabel
                  color="error"
                  title={
                    !followUpStatus?.followUpStatus ? error?.followUpStatus : ""
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <CommonTextField
                  value={followUpStatus?.remark}
                  text="Remark"
                  type="text"
                  onChange={handelChangeFlolowUp}
                  labelSize={{ lg: "14px", md: "14px", xs: "12px" }}
                  labelColor={theme?.palette?.primary?.main}
                  name="remark"
                  rows={3}
                  multiline
                />
              </Grid>
            </Grid>
          </CustomDialog>
        )
      }
    </Grid >
  );
}

export default ViewMember;
